module.exports = __webpack_public_path__ + "img/klep.84b8cb7b.png";